var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "relative bg-slate-100" },
    [
      _c(
        "div",
        { staticClass: "py-4 px-6 flex" },
        [
          _c("BlTextBody2", {
            staticClass: "sticky left-94",
            attrs: {
              text: "Showing all " + _vm.totalMySessions + " appointment(s)"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "sticky top-34 flex rounded-t bg-slate-100",
          style: { zIndex: 11 },
          attrs: { id: "appointment-header" }
        },
        [
          _c(
            "div",
            { staticClass: "flex pl-6 bg-slate-100 sticky left-88 z-10" },
            [
              _c(
                "div",
                {
                  staticClass:
                    "flex border-t border-l border-r border-slate-400 rounded-tl"
                },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "w-20 px-4 py-3 flex-shrink-0 bg-slate-200 rounded-tl"
                    },
                    [
                      _c("BlTextSubtitle3", {
                        staticClass: "text-slate-700",
                        attrs: { text: "ID" }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "w-60 px-4 py-3 flex flex-shrink-0 bg-slate-200 rounded-tl"
                    },
                    [
                      _c("BlTextSubtitle3", {
                        staticClass: "text-slate-700",
                        attrs: { text: "Client name" }
                      })
                    ],
                    1
                  )
                ]
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "w-30 px-4 py-3 border-t border-slate-400 flex-shrink-0 bg-slate-200"
            },
            [
              _c("BlTextSubtitle3", {
                staticClass: "text-slate-700",
                attrs: { text: "Status" }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "w-40 px-4 py-3 border-t border-slate-400 flex-shrink-0 bg-slate-200"
            },
            [
              _c("BlTextSubtitle3", {
                staticClass: "text-slate-700",
                attrs: { text: "Scheduled for" }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "w-40 px-4 py-3 border-t border-slate-400 flex-shrink-0 bg-slate-200"
            },
            [
              _c("BlTextSubtitle3", {
                staticClass: "text-slate-700",
                attrs: { text: "Timeslot" }
              })
            ],
            1
          ),
          _vm._v(" "),
          _vm.enableBranch
            ? _c(
                "div",
                {
                  staticClass:
                    "w-50 px-4 py-3 border-t border-slate-400 flex-shrink-0 bg-slate-200"
                },
                [
                  _c("BlTextSubtitle3", {
                    staticClass: "text-slate-700",
                    attrs: { text: "Branch" }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.enableAppointment
            ? _c(
                "div",
                {
                  staticClass:
                    "w-50 px-4 py-3 border-t border-slate-400 flex-shrink-0 bg-slate-200"
                },
                [
                  _c("BlTextSubtitle3", {
                    staticClass: "text-slate-700",
                    attrs: { text: "Room" }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "w-80 px-4 py-3 border-t border-slate-400 flex-shrink-0 bg-slate-200"
            },
            [
              _c("BlTextSubtitle3", {
                staticClass: "text-slate-700",
                attrs: { text: "Supervisor" }
              })
            ],
            1
          ),
          _vm._v(" "),
          _vm._m(0)
        ]
      ),
      _vm._v(" "),
      _vm._l(_vm.mySessions, function(appointment, idx) {
        return _c("MySessionItem", {
          key: appointment.id,
          attrs: {
            item: appointment,
            isLast: idx + 1 === _vm.mySessions.length
          }
        })
      })
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "flex pr-6 bg-slate-100 sticky right-0 z-10" },
      [
        _c("div", {
          staticClass:
            "w-50 px-4 py-3 border-t border-r border-slate-400 rounded-tr flex-shrink-0 flex-grow bg-slate-200"
        })
      ]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5e305617", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5e305617","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mySessions/table/Table.vue
// module id = null
// module chunks = 